import { Button, Grid } from '@mui/material';
import { RootState, useAppDispatch, useAppSelector } from '../../store/store';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import React from 'react';
import Transition from '../common/Transition';
import { handleCloseSuccessfulNewPredictionDetails } from '../../store/mltester-slice/mltester';
import moment from 'moment';
import { CancelOutlined, CheckCircleOutline } from '@mui/icons-material';
import { Header } from '../common/Header';
import RedirectIconButton from '../common/RedirectIconButton';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

const SuccessfulPredictionDetails = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { successfulNewPredictionOpen, successfulNewPredictionReponse } = useAppSelector((state: RootState) => state.mltester);

    function handleClose() {
        dispatch(handleCloseSuccessfulNewPredictionDetails());
    }

    return(
        <React.Fragment>
            <Dialog
                open={successfulNewPredictionOpen}
                TransitionComponent={Transition}
                keepMounted
                onClose={(_, reason) => {
                    if(reason !== 'backdropClick') handleClose();
                }}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth="sm"
            >
                <Header 
                    title={t('PREDICTION_RESULTS_PREDICTION_TITLE')} 
                    helperIcon={
                        <RedirectIconButton to={'/help/6'} className="helper-icon" >
                            <ContactSupportIcon />
                        </RedirectIconButton>
                    }
                />
                <Grid p={2}>
                    <Grid container mt={1} display={"flex"} flexDirection={"column"} spacing={1}>
                        <Grid item>
                            <Grid mt={1.5} container display={"flex"} justifyContent={"space-between"}>
                                <Grid item>{t('PREDICTION_SUCCESSFUL_RESULT')}</Grid>
                                <Grid item>{successfulNewPredictionReponse?.success ? <CheckCircleOutline sx={{ color: "green" }}/> : <CancelOutlined sx={{ color: 'red' }}/>}</Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container display={"flex"} justifyContent={"space-between"}>
                                <Grid item>{t('PREDICTION_START_DATE_TIME')}</Grid>
                                <Grid item>{moment(successfulNewPredictionReponse?.startPredictDateTimeUTC).format('DD/MM/YYYY hh:mm')}</Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container display={"flex"} justifyContent={"space-between"}>
                                <Grid item>{t('PREDICTION_END_DATE_TIME')}</Grid>
                                <Grid item>{moment(successfulNewPredictionReponse?.endPredictDateTimeUTC).format('DD/MM/YYYY hh:mm')}</Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container display={"flex"} justifyContent={"space-between"}>
                                <Grid item>{t('PREDICTION_DURATION')}</Grid>
                                <Grid item>{successfulNewPredictionReponse?.predictDuration}</Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <DialogActions>
                    <Button size="small" variant='contained' className="button-color"  onClick={handleClose}>{t('CLOSE_BUTTON')}</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default SuccessfulPredictionDetails;